import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StreApperInfo } from 'src/app/models/streapper-info.model';
import { MatDialog } from '@angular/material/dialog';
import { UpdateBannerDialogComponent } from '../update-banner-dialog/update-banner-dialog.component';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'banner',
    templateUrl: './banner.component.html',
    styleUrl: './banner.component.scss',
    standalone: false
})
export class BannerComponent implements OnInit, OnDestroy {
  @Input() profile : StreApperInfo;
  @Input() isSubscribed : boolean = false;

  userRole : string = 'user'; 

  private sub = new Subscription();

  constructor(
    private readonly domSanitizer: DomSanitizer,
    private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.userRole = this.authService.roles.includes("Reporter") ? 'reporter' : 'user';

    this.sub.add(
      this.userService.userInfo$.subscribe((profile) => {
        if (profile != null) {
          this.profile.name = profile.firstName + ' ' + profile.lastName;

          if (this.profile.picture) {
            this.profile.picture = `${
              this.profile.picture
            }?time=${new Date().getTime()}`;
          }
        }
      })
    );

    this.sub.add(
      this.userService.imageUrl$.subscribe((url) => {
        if (url != null) {
          this.profile.picture = url;
        }
      })
    );

    this.sub.add(
      this.userService.bannerImageUrl$.subscribe((url) => {
        if (url != null) {
          this.profile.banner = url;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  getProfilePicture() {
    if (this.profile.picture) {
      if (this.profile.picture.startsWith('blob') || this.profile.picture.startsWith('http')) {
        return this.profile.picture;
      }

      return this.domSanitizer.bypassSecurityTrustUrl(
        'data:image/*;base64,' + this.profile.picture
      );
    }
  }

  edit(): void {
    this.dialog.open<UpdateBannerDialogComponent>(UpdateBannerDialogComponent, {
      autoFocus: false, // To prevent select state of close button in header
      panelClass: 'medium',
      data: {
        profile: this.profile,
        isSubscribed: this.isSubscribed
      },
    });
  }
}
